import { type FC, type ReactNode } from 'react';
import { useFragment, graphql } from 'react-relay';
import { type DEVICE_TYPES } from 'dibs-buyer-layout/exports/deviceTypeEnums.ts';
import { NftNav } from './NftNav.tsx';
import { AvailablePageTypesProvider } from './hooks/useAvailablePageTypes.tsx';
import { PageTypeProvider } from './hooks/usePageType.tsx';
import { DeviceTypeProvider } from './hooks/useDeviceType.tsx';
import { type NftHeaderLayout_viewer$key } from './__generated__/NftHeaderLayout_viewer.graphql.ts';

import { FEATURED, MARKET, EXHIBITIONS, CREATORS, SINGLE_EXHIBITION, SEARCH } from './pageType.ts';

export const NftHeaderLayout: FC<{
    isNftLandingPage?: boolean;
    initialPageType?: string;
    serverDeviceType?: DEVICE_TYPES;
    viewer: NftHeaderLayout_viewer$key;
    children: ReactNode;
}> = ({
    children,
    isNftLandingPage = false,
    initialPageType,
    serverDeviceType,
    viewer: viewerRef,
}) => {
    const viewer = useFragment(
        graphql`
            fragment NftHeaderLayout_viewer on Viewer {
                ...NftNav_viewer
            }
        `,
        viewerRef
    );
    return (
        <DeviceTypeProvider serverDeviceType={serverDeviceType}>
            <AvailablePageTypesProvider
                serverPageTypes={[
                    FEATURED,
                    MARKET,
                    EXHIBITIONS,
                    CREATORS,
                    SINGLE_EXHIBITION,
                    SEARCH,
                ]}
            >
                <PageTypeProvider initialPageType={initialPageType}>
                    <NftNav isNftLandingPage={isNftLandingPage} viewer={viewer} />
                    {children}
                </PageTypeProvider>
            </AvailablePageTypesProvider>
        </DeviceTypeProvider>
    );
};
